import React, { Component } from "react";
import { Form, Input, message } from "antd";
import { Link } from "react-router-dom";
import _ from "lodash";

import { LayoutPage, Button } from "../components";
import { loginAction } from "../actions/page/auth";
import { withRedux } from "../hoc";

const actionToProps = { loginAction };

const mapStateToProps = (state) => {
  return {
    isLogin: _.get(state, "auth.isLogin"),
    isLoginChecked: _.get(state, "auth.isLoginChecked"),
    t: _.get(state, "t"),
    language: _.get(state, "language"),
  };
};

@withRedux(mapStateToProps, actionToProps)
@Form.create()
class Agent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }
  componentDidMount = () => {
    const { isLogin, isLoginChecked } = this.props;
    if (isLoginChecked) {
      if (isLogin) {
        this.props.history.push("/booking");
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isLoginChecked !== this.props.isLoginChecked) {
      if (this.props.isLoginChecked) {
        if (this.props.isLogin) {
          this.props.history.push("/booking");
        }
      }
    }
  }

  submit = async (values) => {
    this.setState({ isLoading: true });
    const username = _.get(values, "username");
    const password = _.get(values, "password");
    const result = await this.props.actions.loginAction(username, password);
    if (_.get(result, "status") !== "success") {
      message.error(_.get(result, "message"));
      this.setState({ isLoading: false });
      return;
    }
    this.setState({ isLoading: false });
    this.props.history.push("/booking");
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.submit(values);
      }
    });
  };
  render() {
    const { t, language } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { isLoading } = this.state;

    let wordShow = (
      <p className="description">
        To create your Tiffany's Show account, please enter your unique
        verification numbers received from Tiffany's Show Pattaya. If you have
        forgotten your verification numbers, please contact Tiffany's Show
        Pattaya at{" "}
        <a href="mailto:sales@tiffany-show.co.th">sales@tiffany-show.co.th</a>{" "}
        to receive a new set of verification numbers.
      </p>
    );
    if (language.currentActive === "cn") {
      wordShow = (
        <p className="description">
          创建您的蒂芬妮秀官网同业账号，请输入蒂芬妮秀给您的独有同业编号。如果您忘记您的同业编号，请联系我们的销售业务
          <a href="mailto:sales@tiffany-show.co.th">sales@tiffany-show.co.th</a>
          重新取得新的同业编号。
        </p>
      );
    } else if (language.currentActive === "th") {
      wordShow = (
        <p className="description">
          เพื่อเข้าใช้งานการสำรองที่นั่ง
          กรุณาสร้างบัญชีเอเจนท์ของท่านโดยการใส่รหัสที่ท่านได้รับจากบริษัท
          ทิฟฟานี่โชว์ พัทยา จำกัด (หากท่านไม่ได้รับรหัส กรุณาติดต่อขอรับรหัสที่{" "}
          <a href="mailto:sales@tiffany-show.co.th">sales@tiffany-show.co.th</a>
          )
        </p>
      );
    }
    return (
      <div className="agent-page">
        <LayoutPage
          pageName="BOX OFFICE"
          image={`${process.env.PUBLIC_URL}/assets/images/boxoffice-banner.jpg`}
        />
        <div className="container">
          {this.props.isLoginChecked ? (
            <div className="row">
              <div className="col-lg-6">
                <div className="block">
                  <h2>{t("Agent Login")}</h2>
                  <Form onSubmit={this.handleSubmit}>
                    <Form.Item>
                      {getFieldDecorator("username", {
                        rules: [
                          {
                            required: true,
                            message: "Please input username",
                          },
                        ],
                      })(<Input placeholder="Username" />)}
                    </Form.Item>
                    <Form.Item>
                      {getFieldDecorator("password", {
                        rules: [
                          {
                            required: true,
                            message: "Please input password",
                          },
                        ],
                      })(<Input type="password" placeholder="Password" />)}
                    </Form.Item>
                    <Form.Item>
                      <Button
                        className="button-login"
                        loading={isLoading}
                        type="primary"
                        htmlType="submit"
                      >
                        {t("Login")}
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="block block-2">
                  <h2>{t("First time login")}</h2>
                  <div>{wordShow}</div>
                  <Link to="/agent-login-first-time">
                    <Button
                      className="button-verify"
                      type="primary"
                      loading={isLoading}
                    >
                      {t("Verify Code")}
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          ) : (
            <div style={{ textAlign: "center", color: "#ffffff" }}>
              Loading...
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Agent;



// WEBPACK FOOTER //
// ./src/pages/Agent.js